export default __webpack_public_path__ + "static/media/roboto-v20-cyrillic_latin-700.424addcd.ttf";